module.exports = __webpack_public_path__ + "media/images/cplook/apple-touch-icon-60x60-b525fbdab14b27d291741c2b8217d29a.png";